import React, { useEffect, useRef, useState } from "react";
import { formatarCnj } from "@/lib/masks";
import axios from "axios";
import { getApiBase } from "@/lib/httpClient";
import { Input } from "@/components/ui/input";

// Vincular processo exigia digitar o ID interno e a versão — dados que o
// usuário não conhece. A busca aceita número CNJ, classe ou assunto e devolve
// os dois campos junto com o processo escolhido.
export default function BuscaProcesso({ onSelect, selecionado, onClear }) {
  const [termo, setTermo] = useState("");
  const [resultados, setResultados] = useState([]);
  const [aberto, setAberto] = useState(false);
  const [buscando, setBuscando] = useState(false);
  const caixa = useRef(null);

  useEffect(() => {
    const fora = (event) => { if (caixa.current && !caixa.current.contains(event.target)) setAberto(false); };
    document.addEventListener("mousedown", fora);
    return () => document.removeEventListener("mousedown", fora);
  }, []);

  useEffect(() => {
    if (selecionado || termo.trim().length < 3) { setResultados([]); return; }
    // Espera a digitação parar: sem isso cada tecla vira uma consulta.
    const timer = setTimeout(async () => {
      setBuscando(true);
      try {
        const { data } = await axios.get(`${getApiBase()}/processos`, {
          withCredentials: true, params: { search: termo.trim() },
        });
        setResultados(Array.isArray(data) ? data.slice(0, 8) : []);
        setAberto(true);
      } catch {
        setResultados([]);
      } finally {
        setBuscando(false);
      }
    }, 350);
    return () => clearTimeout(timer);
  }, [termo, selecionado]);

  if (selecionado) {
    return (
      <div className="flex items-center justify-between gap-2 border border-[#D1DEEE] rounded-md px-3 h-10 bg-[#F4F7FB]">
        <span data-testid="processo-selecionado" className="text-sm text-[#001533] truncate">
          {formatarCnj(selecionado.numero_cnj) || selecionado.processo_id}
        </span>
        <button type="button" data-testid="limpar-processo" onClick={onClear} className="text-[#335480] text-sm hover:text-[#003882]">
          trocar
        </button>
      </div>
    );
  }

  return (
    <div className="relative" ref={caixa}>
      <Input
        data-testid="busca-processo"
        value={termo}
        onChange={(event) => setTermo(event.target.value)}
        onFocus={() => resultados.length && setAberto(true)}
        placeholder="Busque pelo número CNJ, classe ou assunto"
        autoComplete="off"
      />
      {aberto && (
        <div className="absolute z-50 mt-1 w-full bg-white border border-[#D1DEEE] rounded-md shadow-lg max-h-64 overflow-y-auto">
          {buscando && <p className="p-3 text-sm text-[#335480]">Buscando...</p>}
          {!buscando && resultados.length === 0 && (
            <p className="p-3 text-sm text-[#335480]">Nenhum processo encontrado.</p>
          )}
          {resultados.map((processo) => (
            <button
              key={processo.processo_id}
              type="button"
              data-testid={`opcao-${processo.processo_id}`}
              onClick={() => { onSelect(processo); setAberto(false); setTermo(""); }}
              className="block w-full text-left px-3 py-2 hover:bg-[#F4F7FB]"
            >
              <span className="block text-sm text-[#001533]">{formatarCnj(processo.numero_cnj)}</span>
              <span className="block text-xs text-[#335480] truncate">
                {[processo.classe, processo.assunto].filter(Boolean).join(" · ") || "Sem classe informada"}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
